import React, { useEffect } from 'react';
import { Header } from '../Header';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Footer } from '../Footer';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfile } from '../../store/slices/profileSlice';
import { Spinner } from 'react-bootstrap';

import { BottomNavigation } from '../BottomNavigation';

export const Layout = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isHomepage = pathname === '/';
    const isVideoFeed = pathname === '/video-feed';

    const { isAuthenticated } = useSelector((state) => state.auth);
    const { profile, loading } = useSelector((state) => state.profile);

    useEffect(() => {
        document.body.classList.toggle('homepage', isHomepage);
        return () => document.body.classList.remove('homepage');
    }, [isHomepage]);

    // Load profile if authenticated and not loaded yet
    useEffect(() => {
        if (isAuthenticated && !profile && !loading.profile) {
            dispatch(fetchProfile());
        }
    }, [isAuthenticated, profile, loading.profile, dispatch]);

    // Global guard: Redirect to onboarding if not completed
    useEffect(() => {
        if (isAuthenticated && profile) {
            const hasLanguages = profile.languages && profile.languages.length > 0;
            const needsScreening = profile.user_type === 'teacher' && (profile.isQuestionComplete === false || profile.screening_status === 'rejected');
            const isPendingScreening = profile.user_type === 'teacher' && profile.screening_status === 'pending';

            if (needsScreening || !hasLanguages || isPendingScreening) {
                navigate('/onboarding');
            }
        }
    }, [isAuthenticated, profile, navigate]);

    return (
        <>
            {/* Common Menubar Component */}
            <Header />

            <div className="main-content-wrapper position-relative">
                {isAuthenticated && !profile && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                        style={{
                            zIndex: 9999,
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(8px)',
                            WebkitBackdropFilter: 'blur(8px)',
                            transition: 'all 0.3s ease-in-out'
                        }}
                    >
                        <div className="p-4 rounded-4 shadow bg-white bg-opacity-75 text-center d-flex flex-column align-items-center" style={{ border: '1px solid rgba(255, 255, 255, 0.5)' }}>
                            <Spinner animation="border" variant="primary" className="mb-3" />
                            <div className="text-gray-600 fw-bold text-sm">Loading your account details...</div>
                        </div>
                    </div>
                )}
                <Outlet />
            </div>

            {!isVideoFeed && <Footer />}

            {/* Common Bottom Navigation Bar */}
            {/* <BottomNavigation /> */}
        </>
    )
}
